// extracted by mini-css-extract-plugin
module.exports = {"container":"mf-z","header":"nf-z","details":"of-z","link":"pf-z"};